$('#product-slider-mobile').on('init reInit afterChange', function(event, slick, currentSlide){

    var i = (currentSlide ? currentSlide : 0) + 1;
    var total = slick.slideCount;

    var percentage = 100 / total;

    $('.mobile-slider-progress .progress-fill').css({
        width: percentage + '%',
        transform: 'translateX(' + ((i - 1) * 100) + '%'
    });

});

document.addEventListener('DOMContentLoaded', function() {
  const badge = document.querySelector('.gsp-header-badge-wishlist-count');

  if (badge && badge.textContent.trim() === '0') {
    badge.style.display = 'none';
  }
});

$(document).ready(function () {

  $('.noh-product-image-slider').each(function () {

    var $slider = $(this);

    // Progress Bar Update
   $slider.on('init afterChange', function (event, slick, currentSlide) {

    var current = currentSlide || 0;
    var total = slick.slideCount;

    var segment = 100 / total;

    $(this)
      .closest('.gsp-product-card')
      .find('.noh-progress-indicator')
      .css({
          width: segment + '%',
          left: (current * segment) + '%'
      });

});

    // Slick Init
    if (!$slider.hasClass('slick-initialized')) {

      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false, // custom progress bar use kar rahe ho
        fade: false,

        prevArrow:
          '<button class="noh-slider-arrow noh-prev"><svg width="20" height="20" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6" fill="none" stroke="currentColor" stroke-width="2"/></svg></button>',

        nextArrow:
          '<button class="noh-slider-arrow noh-next"><svg width="20" height="20" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6" fill="none" stroke="currentColor" stroke-width="2"/></svg></button>'
      });

    }

  });

});


document.addEventListener("DOMContentLoaded", function () {

  const content = document.getElementById("product-description");
  const button = document.getElementById("description-toggle");

  if (!content || !button) return;

  if (content.scrollHeight > 140) {
    button.style.display = "inline-block";
  }

  button.addEventListener("click", function () {

    content.classList.toggle("expanded");

    if (content.classList.contains("expanded")) {
      button.textContent = "Read Less";
    } else {
      button.textContent = "Read More";
    }

  });

});

$(document).ready(function () {

    function initMegaMenuSlider() {

        if ($(window).width() <= 767) {

            if (!$('.js-image-grid-slider').hasClass('slick-initialized')) {

                $('.js-image-grid-slider').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 2500,
                    arrows: false,
                    dots: true,
                    infinite: true,
                    adaptiveHeight: true
                });

            }

        } else {

            if ($('.js-image-grid-slider').hasClass('slick-initialized')) {
                $('.js-image-grid-slider').slick('unslick');
            }

        }

    }

    initMegaMenuSlider();

    $(window).on('resize', function () {
        initMegaMenuSlider();
    });

});


document.addEventListener("DOMContentLoaded", function () {

    // Desktop only
    if (window.innerWidth < 990) return;

    const offcanvas = document.getElementById("offcanvasMenuMobile");

    if (!offcanvas) return;

    // Arrow click
    document.querySelectorAll("#offcanvasMenuMobile .caret").forEach(function(btn){

        btn.addEventListener("click", function(){

            setTimeout(function(){

                offcanvas.classList.add("menu-expanded");

            },100);

        });

    });

    // Back to first panel
    document.querySelectorAll("#offcanvasMenuMobile .gsp-menu-link").forEach(function(link){

        if(!link.closest(".gsp-submenu")){

            link.addEventListener("click",function(){

                if(!this.parentNode.classList.contains("gsp-menu-has-children")){

                    offcanvas.classList.remove("menu-expanded");

                }

            });

        }

    });

    // Offcanvas close
    offcanvas.addEventListener("hidden.bs.offcanvas",function(){

        offcanvas.classList.remove("menu-expanded");

    });

    // Add Back button
    document.querySelectorAll(".gsp-submenu").forEach(function(menu){

        if(menu.querySelector(".submenu-back")) return;

        menu.insertAdjacentHTML(
            "afterbegin",
            '<button class="submenu-back">← Back</button>'
        );

    });

    // Back button click
    document.addEventListener("click",function(e){

        if(e.target.classList.contains("submenu-back")){

            const sub = e.target.closest(".gsp-submenu");

            bootstrap.Collapse.getOrCreateInstance(sub).hide();

            offcanvas.classList.remove("menu-expanded");

        }

    });

});